import api from "../../services/api";

// Function to activate user account using the full path
export const activateAccount = async (): Promise<void> => {
  // Get the current path from the browser (excluding the domain)
  const currentPath = window.location.pathname;

  // Insert 'api' right after the domain
  const apiPath = `/api/user${currentPath}`;

  // Send POST request to the adjusted path
  const response = await api.post(apiPath);
  return response.data;
};

export const verifyEmail = async (token: string): Promise<any> => {
  const response = await api.get(`/user/verify-email/${token}`);
  return response.data;
};

export const resendUserVerification = async (): Promise<{ message: string; pendingEmail: string }> => {
  const response = await api.post('/user/me/resend-verification');
  return response.data;
};
